'use strict'

export let english_productPlan={
  general: {
    stage: "Release",
    stageMenu: {
      stageActions: "Release actions"
    },
    stagePlan: {
      title: "Release plan",
      projectPhase: "Product",
    }
  },
  schedule: {
    title: "Roadmap",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Release" },
        },
        options: {
          addEntry: { title: "+ Add release" }
        }
      }
    }
  },
  stageDescription: {
    fields: {
      identifier: {
        title: 'Release identifier',
        description: 'Unique identifier for the release'
      },
      name: {
        description: "Name of the release"
      },
      description: {
        help: `Where in the product’s lifecycle is this release (if relevant)?
          What is the goal of this release?
          Briefly summarized, what will this release include and how will it be done? `,
        description: "Short description of what this release is"
      }
    }
  },
  stageTime: {
    fields: {
      period: {
        title: "Release period"
      },
      timeComments: {
        description: "Comments to the time aspect of the release plan"
      }
    }
  },
  stageCost: {
    fields: {
      budget: {
        title: "Release budget",
        help: `Hours: Number of hours needed by internal staff, or hour spent by external resources where the policy is to do project accounting in hours.
          Expenses: Direct expenses received as invoices. This should normally exclude expenses filed as hours. Should not included investments.
          Investments: Capitalized costs for fixed assets
          Total: Manually calculated total cost of the release. Usually total = hours x cost of hours + expenses + investments.`
      }
    }
  },
  stageScheduleScope: {
    fields: {
      scheduleComments: {
        description: "Describe/list what will be delivered in this release, when and by whom"
      }
    }
  }
};



// WEBPACK FOOTER //
// ./views/plan/labels/product/english#productPlan.js